export default hashid => (
  window.open(`${process.env.API_LOCATION}/purchases/${hashid}/pdf/download/?token=${localStorage.getItem('id_token')}`)
);



// WEBPACK FOOTER //
// ./src/app/services/purchase/download.js